//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'LilleModel',
  data () {
    return {
      form: {
        age: '',
        albumin: '',
        bilirubin0: '',
        bilirubin7: '',
        scr: '',
        sec: ''
      },
      hasScore: false,
      disabled: false,
      descTxt: ''
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad'])
  },
  computed: {
    /** 计算公式结果 */
    score () {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            form[key] = Number(form[key])
          }
        }
      }
      console.log(form)
      if (!flag) {
        self.hasScore = false
        self.logit = '...'
        return '...'
      } else {
        let sz = 0
        if (form.scr > 115) {
          sz = 1
        }
        let R = 3.19 - 0.101 * form.age + 0.147 * form.albumin + (0.0165 * (form.bilirubin0 - form.bilirubin7)) - (0.206 * sz) - (0.0065 * form.bilirubin0) - (0.0096 * form.sec)
        let result = (Math.exp(-R) / (1 + Math.exp(-R))).toFixed(3)
        if (result > 0.45) {
          self.descTxt = '预测6个月的存活率为25%，预后不佳，患者可能对类固醇治疗无反应，建议考虑替代疗法和/或转诊移植。'
        } else {
          self.descTxt = '预测6个月的存活率为85%，预后良好'
        }
        self.hasScore = true
        return String(result)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Hepatology/LilleModel.vue